import { parsePaymentTermRule } from '@ztechapps/common.utils'
import { PaymentTermTypeEnum } from '@ztechapps/common.contract'

/**
 * An order is "on account" (billed on credit, settled in QBO) when its stored
 * payment-term value parses to a credit rule — standard (Net N) or downPayment
 * (deposit). A card term, no term, or an unparseable term is NOT on account.
 *
 * The status gate (still Unpaid / Partially Paid) is applied separately by callers
 * — this only answers "is the term a credit term".
 */
export const isOnAccountTerm = (paymentTerms?: string): boolean => {
  const rule = parsePaymentTermRule(paymentTerms)
  return rule?.type === PaymentTermTypeEnum.standard || rule?.type === PaymentTermTypeEnum.downPayment
}
